import 'react';
import './Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import { css as css$1 } from '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';
import './ColorMode/ColorModeContext.js';
import 'lodash/kebabCase';
import { t as theme, p as palette, s as space } from './getCSSFromStyleObject.js';
import 'lodash/uniq';
import 'reakit/Id';
import { darken } from './utils/colors.js';
import 'deepmerge';
import 'lodash/set';
import 'lodash/get';
import 'capsize';
import { getHiddenScrollbarStyles } from './utils/getHiddenScrollbarStyles.js';
import '@emotion/is-prop-valid';
import './utils/OutsideClickHandler.js';
import { a as Select } from './Select.styles.js';

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  padding: ", "rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  & > input {\n    border-color: transparent;\n    border-bottom-color: ", ";\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    padding: ", "rem 0;\n    overflow-y: scroll;\n\n    ", ";\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n          background-color: ", ";\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    font-weight: 300;\n\n    &[aria-selected=\"true\"] {\n      background-color: ", ";\n      color: ", ";\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      ", "\n    }\n\n    &[aria-disabled=\"true\"] {\n      color: ", ";\n    }\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", "rem ", "rem;\n  width: 100%;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: calc(100% - 4rem);\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  min-width: 4rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n      & {\n        border-color: ", ";\n        box-shadow: ", " 0px 0px 0px 3px !important;\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n\n  cursor: default;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.4em 0.8em;\n\n  &[aria-expanded=\"true\"] {\n    border-color: ", ";\n    box-shadow: ", " 0px 0px 0px 3px !important;\n  }\n\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    max-width: 100%;\n    width: 100%;\n    max-height: ", ";\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var SelectMenu = function SelectMenu(styleProps) {
  return css(_templateObject(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuPopover = function SelectMenuPopover(styleProps) {
  return css(_templateObject2(), styleProps.popoverHeight, theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuButton = function SelectMenuButton(styleProps) {
  return css(_templateObject3(), Select(styleProps), palette('primary')(styleProps), palette('primaryTint')(styleProps), styleProps.state && css$1(_templateObject4(), palette("" + styleProps.state)(styleProps), palette(styleProps.state + "Tint")(styleProps)), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuButtonIcon = function SelectMenuButtonIcon(styleProps) {
  return css(_templateObject5(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuClearButtonWrapper = function SelectMenuClearButtonWrapper(styleProps) {
  return css(_templateObject6(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuClearButton = function SelectMenuClearButton(styleProps) {
  return css(_templateObject7(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuButtonIconsWrapper = function SelectMenuButtonIconsWrapper(styleProps) {
  return css(_templateObject8(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuButtonText = function SelectMenuButtonText(styleProps) {
  return css(_templateObject9(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuStaticItem = function SelectMenuStaticItem(styleProps) {
  return css(_templateObject10(), space(1.5)(styleProps), space(4)(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuItem = function SelectMenuItem(styleProps) {
  return css(_templateObject11(), palette('primaryTint')(styleProps), palette('primary900')(styleProps), darken(0.01, 'primaryTint')(styleProps), styleProps.tabIndex === 0 && css$1(_templateObject12(), darken(0.01, 'primaryTint')(styleProps)), palette('gray100')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuItemText = function SelectMenuItemText(styleProps) {
  return css(_templateObject13(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuItemsWrapper = function SelectMenuItemsWrapper(styleProps) {
  return css(_templateObject14(), space(2)(styleProps), getHiddenScrollbarStyles(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuSearchInputWrapper = function SelectMenuSearchInputWrapper(styleProps) {
  return css(_templateObject15(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuSearchInput = function SelectMenuSearchInput(styleProps) {
  return css(_templateObject16(), palette('white800')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuTagsWrapper = function SelectMenuTagsWrapper(styleProps) {
  return css(_templateObject17(), palette('white600')(styleProps), palette('white800')(styleProps), space(2)(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var SelectMenuField = function SelectMenuField(styleProps) {
  return css(_templateObject18(), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var SelectMenu_styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SelectMenu: SelectMenu,
  SelectMenuPopover: SelectMenuPopover,
  SelectMenuButton: SelectMenuButton,
  SelectMenuButtonIcon: SelectMenuButtonIcon,
  SelectMenuClearButtonWrapper: SelectMenuClearButtonWrapper,
  SelectMenuClearButton: SelectMenuClearButton,
  SelectMenuButtonIconsWrapper: SelectMenuButtonIconsWrapper,
  SelectMenuButtonText: SelectMenuButtonText,
  SelectMenuStaticItem: SelectMenuStaticItem,
  SelectMenuItem: SelectMenuItem,
  SelectMenuItemText: SelectMenuItemText,
  SelectMenuItemsWrapper: SelectMenuItemsWrapper,
  SelectMenuSearchInputWrapper: SelectMenuSearchInputWrapper,
  SelectMenuSearchInput: SelectMenuSearchInput,
  SelectMenuTagsWrapper: SelectMenuTagsWrapper,
  SelectMenuField: SelectMenuField
});

export { SelectMenu_styles as S, SelectMenu as a, SelectMenuPopover as b, SelectMenuItemsWrapper as c, SelectMenuButton as d, SelectMenuButtonText as e, SelectMenuButtonIconsWrapper as f, SelectMenuButtonIcon as g, SelectMenuSearchInputWrapper as h, SelectMenuSearchInput as i, SelectMenuTagsWrapper as j, SelectMenuItemText as k, SelectMenuClearButtonWrapper as l, SelectMenuClearButton as m, SelectMenuStaticItem as n, SelectMenuItem as o, SelectMenuField as p };
